var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOnboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-users 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.7004 21.932C35.9484 22.5 39.7604 24.004 39.9884 26.436L40.0004 26.668V35.832C40.0004 36.256 39.6964 36.6 39.2924 36.656L39.1684 36.668H34.9164C34.9524 36.488 34.9764 36.304 34.9884 36.116L35.0004 35.832V26.668C35.0004 24.7 34.0844 23.152 32.7004 21.932ZM30.0004 8.33203C32.7684 8.33203 34.9844 10.568 34.9844 13.332C34.9844 16.012 32.9084 18.188 30.2644 18.328L30.0004 18.332C29.4684 18.332 28.9524 18.252 28.4844 18.1C29.4164 16.732 29.9844 15.116 29.9844 13.332C29.9844 11.552 29.4324 9.91603 28.4844 8.56803C28.9524 8.41603 29.4684 8.33203 30.0004 8.33203Z",
    fill: "#3CAAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.668 21.668C24.924 21.668 31.364 23.26 31.656 26.44L31.668 26.668V36.668C31.668 37.528 31.008 38.24 30.168 38.324L30 38.332H13.332C12.472 38.332 11.76 37.676 11.676 36.836L11.668 36.668V26.668C11.668 23.332 18.332 21.668 21.668 21.668ZM6.668 11.668C7.528 11.668 8.24 12.324 8.324 13.164L8.332 13.332V16.668H11.668C12.584 16.668 13.332 17.416 13.332 18.332C13.332 19.192 12.676 19.904 11.836 19.992L11.668 20H8.332V23.332C8.332 24.192 7.676 24.904 6.836 24.992L6.668 25C5.808 25 5.096 24.34 5.008 23.504L5 23.332V20H1.668C0.752 20 0 19.252 0 18.332C0 17.472 0.66 16.76 1.496 16.676L1.668 16.668H5V13.332C5 12.416 5.752 11.668 6.668 11.668ZM21.668 8.33203C24.432 8.33203 26.652 10.568 26.652 13.332C26.652 16.012 24.576 18.188 21.932 18.328L21.668 18.332C18.9 18.332 16.668 16.1 16.668 13.332C16.668 10.568 18.9 8.33203 21.668 8.33203Z",
    fill: "#3CAAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOnboard);
export default __webpack_public_path__ + "static/media/New Onboard.d0c307bc67aee65d6de874e53fc62910.svg";
export { ForwardRef as ReactComponent };